import { SELECIONAR_USUARIO } from '../../actions/types'

const initialState = undefined
const estadoInicial = { 
  pessoa: {},
  usuarioSelecionado: {
    comissao: '00.00',
    ddi: '+55',
    siglaPais: 'BRA'
  }

}

export default function reducerUsuarioSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_USUARIO: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
